import React from 'react';
import PropTypes from 'prop-types';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';

import Logo from 'bento-ordering/base/components/Logo';
import StyledAppBar from 'components/AppBar/StyledMuiAppBar';
import { Container } from 'components/Containers';
import { LINK_TO_BENTO_WEBSITE } from 'bento-ordering/base/constants/endpoints';

const BaseAppBar = props => {
  const {
    ownState,
    logo,
    name,
    logoLinkPath,
    children,
    ToolbarProps = {}
  } = props;

  const { sx: toolbarSx = {} } = ToolbarProps;

  return (
    <StyledAppBar color="inherit" ownState={ownState} data-testid="app-bar">
      <Container>
        <Toolbar sx={toolbarSx}>
          {logo && (
            <Box>
              <Logo
                src={logo}
                alt={name}
                dataTestId="restaurant-logo"
                logoLinkPath={logoLinkPath || LINK_TO_BENTO_WEBSITE}
              />
            </Box>
          )}
          {children}
        </Toolbar>
      </Container>
    </StyledAppBar>
  );
};

BaseAppBar.propTypes = {
  children: PropTypes.node,
  logo: PropTypes.string,
  name: PropTypes.string,
  logoLinkPath: PropTypes.string,
  ownState: PropTypes.object,
  ToolbarProps: PropTypes.object
};

export default React.memo(BaseAppBar);
